import { useAuthStore } from '../../stores/auth'

const hasAnyPermission = (permissions) => {
    const authStore = useAuthStore();
    return permissions.some(permission => authStore.hasPermission(permission));
};

export const adminRoutes = [
    {
        path: 'roles',
        name: 'roles',
        component: () => import('../../views/RolesView.vue'),
        meta: {
            requiresAuth: true,
            requiredPermission: 'roles.view'
        }
    },
    {
        path: 'users',
        name: 'users',
        component: () => import('../../views/UsersView.vue'),
        meta: {
            requiresAuth: true,
            requiredPermission: 'users.view'
        }
    },
    {
        path: 'audit-logs',
        name: 'audit-logs',
        component: () => import('../../views/AuditLogs.vue'),
        meta: {
            requiresAuth: true,
            requiredPermission: 'audit.view'
        }
    },
    {
        path: 'sms-management',
        name: 'sms-management',
        component: () => import('../../views/SmsManagement.vue'),
        meta: {
            requiresAuth: true,
            title: 'Messaging Center',
            permissions: ['sms.view', 'sms.manage'],
            breadcrumb: [
                { name: 'Messaging Center' }
            ]
        },
        beforeEnter: (to, from, next) => {
            if (hasAnyPermission(to.meta.permissions)) {
                next();
            } else {
                next({ name: 'forbidden' });
            }
        }
    }
];
